import React, {useEffect, useState} from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select, CircularProgress, ListItemText} from '@mui/material';
import nationalitiesBDD from '../BDD/nationalities.js';

export default function SelectNationality({ name, selectedNationality, handleChange }) {

    const [nationalities] = useState(nationalitiesBDD.sort((a, b) => a.localeCompare(b)))

    if(!nationalities)
        return <CircularProgress />

        return (
            <FormControl fullWidth>
                <InputLabel>Nationalité</InputLabel>
                <Select
                    name={name}
                    label="Nationalité"
                    value={selectedNationality}
                    onChange={handleChange}
                >
                    {nationalities.map((nationality) => (
                        <MenuItem key={nationality} value={nationality}>
                            <ListItemText primary={nationality} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
          );
}